import React, { useState } from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { Input } from "../../../../../../shared/Input/Input";
import { authService } from "../../../../../../services/AuthService";
import { not } from "../../../../../../utilities/fp";
import { EyeIcon } from "../../../../../../assets/Icons/EyeIcon";
import { EyeOffIcon } from "../../../../../../assets/Icons/EyeOffIcon";

export function SecurityQuestion({ answer, setAnswer, isDisabled }) {
  const [isAnswerVisible, setIsAnswerVisible] = useState(false);
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  const question = authService.getPreLoginData().securityQuestion;

  return (
    <div className={styles.root}>
      <div>{t("answerTitle")}</div>
      <b className={styles.question}>{question}</b>
      <div>
        <Input
          placeholder={t("answerPlaceholder")}
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          isDisabled={isDisabled}
          type={isAnswerVisible ? "text" : "password"}
          rightAdornment={
            <button
              onClick={() => setIsAnswerVisible(not)}
              className={styles.inputVisibleButton}
            >
              {isAnswerVisible ? <EyeIcon /> : <EyeOffIcon />}
            </button>
          }
        />
        <span className={styles.note}>{t("answerNote")}</span>
      </div>
    </div>
  );
}
